export default __webpack_public_path__ + "static/media/icons - Search.d94bcb77.svg";